// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6250":"495f98d93f6a274b","8443":"fe32267ec2de1346"}[chunkId] + ".css";
};